import { render, staticRenderFns } from "./CreateNewContractButton.vue?vue&type=template&id=4e3eb17a&scoped=true"
import script from "./CreateNewContractButton.vue?vue&type=script&lang=js"
export * from "./CreateNewContractButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3eb17a",
  null
  
)

export default component.exports